import { ImportSetAdminTranslation } from 'app/area/import-sets-administration/constants';
import { ChangeOptionType } from 'app/area/import-sets-administration/list/types';
import { ImportSetAdminListState } from 'app/area/import-sets-administration/list/types-store';
import { FilterOption } from 'app/components/options-handler/types';
import { LoadOptions } from 'app/types-shared';
import { ValidationProps } from 'ui';

export enum AddNewImportSetField {
  copyImportSet = 'copyImportSet'
}

export interface AddNewImportSetProps {
  list: ImportSetAdminListState;
  options: {
    [key: string]: FilterOption;
  };
  translation: ImportSetAdminTranslation;
  validation: { [key: string]: ValidationProps };
  locale: string;
  onClose: () => void;
  updateByKey: <T>(key: string, value: T) => void;
  resetValidation: (key: string) => void;
  updateIsDirty: (value: boolean) => void;
  updateState: (value: ChangeOptionType) => void;
  clearAddImportSet: () => void;
  loadOptions: (id: string,
    componentEndpoint: string,
    loadOptionsParams: LoadOptions,
    optionsParams?: any) => void;
}
